const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/middleware/kisapi/cache.ts';
/**
 * Caching middleware to be used with kisapi redux middleware
 */

import { Store } from 'redux';
import { actionCacheRequest, actionClearCache } from '../../actions/networkActions';
import { GenericRequest } from '../genericMiddleware';

/**
 * this function listens for a cache flag on the incoming IKisApiAction
 * and if present triggers a cache action to put the successful http
 * response into a designated subtree of the store. If a cached IKisApiAction
 * is found in the store it is immediately returned without passing the object
 * to the follwing transformation stages.
 * @param store gets passed down from middleware and comes from redux framework
 * @return A middleware function
 */
export default function cache(store: Store) {
    return (next: any) => async (action: GenericRequest) => {
        if (action.requestConfig.cache !== 'no-cache') {
            const cache = store.getState().network.get('cache');
            const cachedContent = cache.get(action.endpoint);
            if (cachedContent !== undefined) {
                return Promise.resolve(cachedContent.clone());
            }
        } else {
            store.dispatch(actionClearCache(action.endpoint));
        }
        const response = await next(action);
        if (action.requestConfig.cache === 'force-cache' && response.status === 200) {
            store.dispatch(actionCacheRequest(action.endpoint, response.clone()));
        }
        return response;
    };
}
